<div
  class="modal-overlay"
  [class.active]="isActive"
  (click)="onCancel()">
  <div class="modal confirmation-modal" (click)="$event.stopPropagation()">
    <button class="close-modal" (click)="onCancel()">x</button>

    <div class="confirmation-content">
      <h2 class="modal-title">Review punks before copying</h2>

      <div class="warning-message">
        <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22" fill="currentColor">
          <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"/>
        </svg>
        <div>
          <p style="margin-bottom: 1.5rem;">
            Copying a bid is a powerful feature but could be used to bait unsuspecting users.
          </p>
          <p>
            Please carefully review <strong>all {{ punkIds.length }} CryptoPunks</strong> targeted by this bid before proceeding. Scroll through the entire list to confirm you have reviewed them.
          </p>
        </div>
      </div>

      <div
        #punksScrollContainer
        class="punks-scroll-container"
        (scroll)="onScroll()">
        <div class="punks-grid">
          <div
            *ngFor="let punkId of punkIds"
            class="punk-item">
            <img
              [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
              [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
              [alt]="'Punk #' + punkId"
              class="punk-image"
            />
            <span class="punk-id">#{{ punkId }}</span>
          </div>
        </div>
      </div>

      <div class="actions">
        <span class="cancel-btn-wrapper">
          <button class="cancel-btn" (click)="onCancel()">Cancel</button>
        </span>
        <span
          class="confirm-btn-wrapper"
          tippy
          [options]="{
            content: 'Scroll down to review all punks before confirming',
            placement: 'top',
            theme: 'punks',
            trigger: hasScrolledToBottom ? 'manual' : 'mouseenter'
          }">
          <button
            class="confirm-btn"
            [class.disabled]="!hasScrolledToBottom"
            [disabled]="!hasScrolledToBottom"
            (click)="onConfirm()">
            {{ cloneBidConfirmLabel }}
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
